import React from 'react';
import _isObject from 'lodash/isObject';
import _isBoolean from 'lodash/isBoolean';

import ObjectDisplay from 'components/ObjectDisplay';
import BooleanDisplay from 'components/BooleanDisplay'

export default props => {
  const {label, value} = props;
  if (_isObject(value)) {
    return (
      <div className="value-display object-value">
        <label>{label}</label>
        <ObjectDisplay object={value} />
      </div>
    );
  } else if (_isBoolean(value)) {
    return (
      <div className="value-display">
        <label>{label}</label>
        <div><BooleanDisplay value={value}/></div>
      </div>
    );
  } else {
    return (
      <div className="value-display">
        <label>{label}</label>
        <div>{value}</div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ValueDisplay.jsx